import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { SmoothScroll } from "@/components/SmoothScroll";
import Home from "@/pages/Home";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Admin from "@/pages/Admin";

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll>
        <div className="grain min-h-screen bg-ink text-body">
          <Header />
          <main className="overflow-x-clip">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/subscriptions" element={<Navigate to="/#pricing" replace />} />
              <Route path="/pricing" element={<Navigate to="/#pricing" replace />} />
              <Route path="/system-requirements" element={<Navigate to="/" replace />} />
              <Route path="/privacy-policy" element={<Privacy />} />
              <Route path="/video" element={<Navigate to="/" replace />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/support" element={<Navigate to="/contact" replace />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </SmoothScroll>
    </BrowserRouter>
  );
}

export default App;
